(() => {
  function initBundleFixed(productId) {
    const data = window.bundleFixedData?.[productId];
    const atcBtn = document.getElementById(`bundle-fixed-atc-${productId}`);
    const selectedEl = document.getElementById(`bundle-fixed-selected-${productId}`);
    const progressBar = document.getElementById(`bundle-fixed-progress-${productId}`);

    if (!data || !atcBtn) return;

    const total = data.variants.reduce((sum, v) => sum + v.quantity, 0);

    // Fixed bundle: quantities are pre-determined, always fulfills required
    if (selectedEl) selectedEl.textContent = total;
    if (progressBar) progressBar.style.width = '100%';

    atcBtn.disabled = false;
    atcBtn.removeAttribute('aria-disabled');

    const hint = document.getElementById(`bundle-fixed-hint-${productId}`);
    if (hint) hint.hidden = true;

    atcBtn.addEventListener('click', async () => {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');

      try {
        // Tag every line item with bundle properties (underscore-prefixed = hidden from customer)
        const bundleId = `fixed-${productId}-${Date.now()}`;
        const items = data.variants.map((v) => ({
          id: v.id,
          quantity: v.quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_type: 'fixed',
            _bundle_required: data.required,
          },
        }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) throw new Error('cart/add failed');

        const cartType = window.themeVariables?.settings?.cartType;

        if (cartType === 'message') {
          const banner = document.createRange().createContextualFragment(`
            <div class="banner banner--success" role="status" aria-live="polite">
              ${window.themeVariables?.strings?.addedToCart ?? '已加入購物車'}
            </div>
          `).firstElementChild;
          atcBtn.closest('td').prepend(banner);
          setTimeout(() => banner.remove(), 2500);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.show();
        } else if (cartType !== 'message') {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('[bundle-fixed] add to cart error:', err);
      } finally {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-busy');
      }
    });
  }

  document.querySelectorAll('[id^="bundle-fixed-"]').forEach((el) => {
    const match = el.id.match(/^bundle-fixed-(\d+)$/);
    if (match) initBundleFixed(match[1]);
  });
})();
